(() => {
  'use strict';
  const bar = document.getElementById('wam-sticky-atc');
  const root = bar?.closest('.product-information--inner');
  const action = root?.querySelector('#AddToCart');
  const priceContainer = root?.querySelector('[id^="price-"]');
  if (!bar || !root || !action || !priceContainer || bar.dataset.wamReady) return;
  const button = bar.querySelector('button');
  const priceLabel = bar.querySelector('.wam-sa-price');
  const variantLabel = bar.querySelector('.wam-sa-variant');
  const form = action.form;
  if (!button || !priceLabel || !form) return;
  bar.dataset.wamReady = 'true';
  // Use the attribute: the native form's input named "id" shadows form.id.
  button.setAttribute('form', form.getAttribute('id'));
  let variants = [];
  try {
    variants = JSON.parse(root.querySelector('variant-selects script[type="application/json"]')?.textContent || '[]');
  } catch (_) { /* Keep the server-rendered variant label if native JSON is unavailable. */ }
  const visible = node => node && node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden';
  const sync = () => {
    const selectedId = form.querySelector('[name="id"]')?.value;
    const selected = variants.find(variant => String(variant.id) === selectedId);
    if (variantLabel && selected && variantLabel.textContent !== selected.title) variantLabel.textContent = selected.title;
    const discounted = priceContainer.querySelector('.amount.discounted');
    const amount = visible(discounted) ? discounted : [...priceContainer.querySelectorAll('.amount')]
      .find(node => !node.closest('del, s') && visible(node));
    const price = amount?.textContent.trim() || '';
    if (priceLabel.textContent !== price) priceLabel.textContent = price;
    button.disabled = action instanceof HTMLButtonElement && action.disabled;
    const label = action.textContent.trim();
    if (button.textContent !== label) button.textContent = label;
  };
  const mobile = window.matchMedia('(max-width: 767px)');
  const updateVisibility = () => {
    const rect = action.getBoundingClientRect();
    const nativeOnScreen = visible(action) && rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
    bar.style.display = mobile.matches && !nativeOnScreen ? 'flex' : 'none';
  };
  let frame = 0;
  const scheduleVisibility = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = 0; updateVisibility(); });
  };
  sync();
  updateVisibility();
  new MutationObserver(sync).observe(priceContainer, {
    childList: true, subtree: true, characterData: true,
    attributes: true, attributeFilter: ['class', 'style', 'hidden']
  });
  new MutationObserver(sync).observe(action, {
    childList: true, subtree: true, characterData: true,
    attributes: true, attributeFilter: ['disabled']
  });
  form.addEventListener('change', sync);
  document.addEventListener('product:variant-change', sync);
  button.addEventListener('click', () => { sync(); if (!button.disabled) action.click(); });
  window.addEventListener('scroll', scheduleVisibility, { passive: true });
  window.addEventListener('resize', scheduleVisibility);
  if ('IntersectionObserver' in window) new IntersectionObserver(updateVisibility).observe(action);
})();
